<template>
  <Main ref="main" :tableData="tableData" />
</template>

<script>
import Main from './main'
export default {
  components: { Main },
  data() {
    return { tableData: [] }
  },
  methods: {
    addContent(content) {
      if (!content) return

      const $main = this.$refs.main
      const { componentPositionCn, optionName } = content

      // 校验是否存在相同【成分】【位置】
      const tableData = $main.getTableData()
      const findIndex = tableData.findIndex((row) => {
        return (
          (row.componentPositionCn || '') === (componentPositionCn || '') &&
          row.optionName === optionName
        )
      })

      if (findIndex >= 0) {
        tableData[findIndex] = { ...tableData[findIndex], ...content }
        $main.reloadData(tableData)
        return
      }

      $main.insertAt(content)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
